import ProductCategoryService from '../../../modules/productCategory/productCategoryService'
import Errors from '../../../modules/shared/error/errors'
import { push } from 'redux-first-history'

const prefix = 'PRODUCTCATEGORY_VIEW'

const productCategoryViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: productCategoryViewActions.FIND_STARTED,
      })

      const record = await ProductCategoryService.find(id)

      dispatch({
        type: productCategoryViewActions.FIND_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: productCategoryViewActions.FIND_ERROR,
      })

      dispatch(push('/product-category'))
    }
  },
}

export default productCategoryViewActions
